import { OrderBy } from '@chegg-wt/core/globalTypes'
import { CITATION_LIST_NAME_LOWER_PLURAL } from '@chegg-wt/core/constants/citations'
import { ProjectTypeKeys } from '@chegg-wt/core/constants/projectTypeKey'

export const ActionTypes = {
  SEARCH_PROJECTS: 'REQUEST/PROJECTS/SEARCH',
  FETCH_PROJECTS: 'REQUEST/PROJECTS',
  FETCH_PROJECTS_SUCCEEDED: 'SUCCEEDED/PROJECTS/FETCH',
  FETCH_PROJECTS_ERROR: 'ERROR/PROJECTS/FETCH',
  SORT_PROJECTS: 'REQUEST/PROJECTS/SORT',
  SORT_PROJECTS_ERROR: 'ERROR/PROJECTS/SORT',
  STAR_PROJECT: 'REQUEST/PROJECT/STAR',
  STAR_PROJECT_ERROR: 'ERROR/PROJECT/STAR',
  UNSTAR_PROJECT: 'REQUEST/PROJECT/UNSTAR',
  UNSTAR_PROJECT_ERROR: 'ERROR/PROJECT/UNSTAR',
  SET_PROJECT_FILTER: 'PROJECTS/SET_FILTER',
  BATCH_DELETE_PROJECTS: 'REQUEST/PROJECT/BATCH_DELETE',
  CREATE_PROJECT: 'REQUEST/PROJECT/CREATE',
  CREATE_PROJECT_ERROR: 'ERROR/PROJECT/CREATE',
  EDIT_PROJECT: 'REQUEST/PROJECT/EDIT',
  EDIT_PROJECT_ERROR: 'ERROR/PROJECT/EDIT',
  SET_SORT_NAME: 'REQUEST/PROJECT/SET_SORT_NAME',
  SET_ORDER: 'REQUEST/PROJECT/SET_ORDER',
} as const

// misc values
export const basicProStyles = [
  {
    name: 'MLA9',
    value: 'mla9',
  },
  {
    name: 'MLA8',
    value: 'mla8',
  },
  {
    name: 'MLA7',
    value: 'mla7',
  },
  {
    name: 'APA6',
    value: 'apa',
  },
  {
    name: 'APA7',
    value: 'apa7',
  },
  {
    name: 'Chicago',
    value: 'chicago',
  },
  {
    name: 'CSE',
    value: 'council-of-science-editors',
  },
  {
    name: 'Chicago Author-Date',
    value: 'chicago-author-date',
  },
  {
    name: 'ACS',
    value: 'american-chemical-society',
  },
  {
    name: 'Harvard 1',
    value: 'harvard1',
  },
  {
    name: 'ASA',
    value: 'american-sociological-association',
  },
]

export const basicFreeStyles = [
  {
    name: 'MLA9',
    value: 'mla9',
  },
  {
    name: 'MLA8',
    value: 'mla8',
  },
  {
    name: 'MLA7',
    value: 'mla7',
  },
]

export const ProjectTypeKeyToTitle = {
  [ProjectTypeKeys.ALL]: `All ${CITATION_LIST_NAME_LOWER_PLURAL}`,
  [ProjectTypeKeys.STARRED]: 'Starred',
} as const

export const OrderByTypes = {
  DATE: 'updatedAt' as OrderBy,
  NAME: 'name' as OrderBy,
}

export const SortNames = {
  NAME: 'Name',
  DATE: 'Date',
} as const

export const sortOptionsList = [SortNames.NAME, SortNames.DATE]

export const sortNameToOrderByTypeMap = {
  [SortNames.DATE]: OrderByTypes.DATE,
  [SortNames.NAME]: OrderByTypes.NAME,
}

export const ITEMS_PER_PAGE = 10
